<!--  -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">汽配编码</div>
                <el-autocomplete
                    ref="search_1"
                    size="small"
                    style="width:160px;margin: 0 10px 10px 0;"
                    v-model="searchData.APCode"
                    :fetch-suggestions="searchAPCode"
                    :debounce="500"
                    placeholder="请输入配件编码"
                    :trigger-on-focus="false"
                    @select="stopSearch"
                ></el-autocomplete>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询（Enter）</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多条件 (F2)</el-button>
                <el-button size="small" icon="el-icon-refresh"  class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                <el-button size="small" type="warning" class="search-btn" @click="openDialog2">结束订单</el-button>
                <el-button size="small" type="warning" class="search-btn" @click="openDialog">结束单项明细</el-button>
                <el-button size="small" icon="el-icon-setting" type="primary" class="search-btn" @click="showTableSetDialog()">表格设置</el-button>

            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }" 
                :data="tableData"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                border
                style="width: 100%"
                v-loading="loading"
                :tableCode="tableCode"
            >
                <el-table-column type="selection"  :selectable="selectInit" width="50"></el-table-column>
                <template v-for="(col,index) in columnShowSets">
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '80px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'State'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.IsTrans ? '已完成':'并入在订' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'OrderCode'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.OrderCode}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'CusName'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.CusName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'APCode'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.APCode}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'EntpTempGoodsName'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.EntpTempGoodsName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'AutoSerise'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.AutoSerise }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'Count'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.Count }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'TranCount'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.TranCount }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'PlanCount'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.PlanCount }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'PurIntendCount'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.PurIntendCount }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'Price'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.Price }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'Cate'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.Cate }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'Remark'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.Remark }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'Cteator'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.Creator }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'QTime'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.QTime }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'Updatetor'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.Updatetor }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'UpdateTime'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.IsTrans ? 'red' : '' }">
                                {{ scope.row.UpdateTime }}
                            </div>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" :modal="false" title="结束单项明细" v-dialog-drag :visible.sync="visible" width="500px" id="change-dialog">
            <div class="dialog-content" v-if="visible">
                <div class="flex">
                    <label class="input-label">结束原因</label>
                    <el-input size="small" v-model="reson" placeholder="请输入原因"></el-input>
                </div>
                <div class="dialog-footer">
                    <el-button size="small" @click="colseDialog">关闭（Esc）</el-button>
                    <el-button class="btn-primary" size="small" @click="submitGoodsVs">提交（Enter）</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :modal="false" title="结束订单" v-dialog-drag :visible.sync="visible2" width="500px" id="change-dialog">
            <div class="dialog-content" v-if="visible2">
                <div class="flex">
                    <label class="input-label">结束单号</label>
                    <el-input size="small" v-model.Trim="inquiryCode" placeholder="请输入需要结束的订单号"></el-input>
                </div>
                <div class="dialog-footer">
                    <el-button size="small" @click="colseDialog2">关闭（Esc）</el-button>
                    <el-button class="btn-primary" size="small" @click="submitOrderCodeVs">提交（Enter）</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="搜索条件"
            :visible.sync="dialogSearchVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-inquiry-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px;"
        >
            <div class="dialog-content">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="供应商">
                        <el-select
                            ref="search_sup"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.EntpCusName"
                            remote
                            filterable
                            clearable
                            allow-create
                            placeholder="请输入供应商名称"
                            :remote-method="searchSupplier"
                            v-select-scroll-more="searchSupplierLoad"
                        >
                            <el-option v-for="item in supplierOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="询价单号">
                        <el-input size="small" v-model.trim="searchData.InquiryCode" clearable v-filter-special-char="searchData.InquiryCode" placeholder="询价单号"></el-input>
                    </el-form-item>
                    <el-form-item label="汽配编码">
                        <el-autocomplete
                            ref="search_1"
                            size="small"
                            style="width:100%"
                            v-model="searchData.APCode"
                            :fetch-suggestions="searchAPCode"
                            :debounce="500"
                            placeholder="请输入汽配编码"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="汽配名称">
                        <el-autocomplete
                            ref="search_2"
                            size="small"
                            style="width:100%"
                            v-model="searchData.GoodName"
                            :fetch-suggestions="searchGoodName"
                            :debounce="500"
                            placeholder="请输入汽配名称"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="适用车型">
                        <el-autocomplete
                            ref="search_3"
                            size="small"
                            style="width:100%"
                            :debounce="500"
                            v-model="searchData.AutoSerise"
                            :fetch-suggestions="searchAutoSerise"
                            placeholder="请输入车型"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="互换码">
                        <el-input size="small" v-model.trim="searchData.GoodCode" placeholder="请输入互换码"></el-input>
                    </el-form-item>
                    <el-form-item label="订单状态">
                        <el-select style="width: 100%" size="small" v-model="searchData.State">
                            <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建人">
                        <el-select
                            v-model="searchData.StaffId"
                            filterable
                            style="width:100%"
                            size="small"
                            clearable
                            placeholder="请选择"
                        >
                            <el-option
                            v-for="(item, index) in SIdList"
                            :key="index"
                            :label="item.EmployeeName"
                            :value="item.EmployeeId"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="询价日期">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDateTimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="更新日期">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime1"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="closetableSetDialog" :visible.sync="tableSetsVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="tableSetsVisible">
                <tableSets :tableCode="tableCode" @closeDialog="closetableSetDialog"></tableSets>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import elTableColumn from '@/components/common/chjtablecolumn';
import tableSets from '@/components/common/tableSets_v2.vue';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        tableSets,
        elTableColumn
    },
    data() {
        return {
            tableCode: 'XJOrderGoodsTable',
            visible: false,
            visible2:false,
            loading:false,
            optionLoading:false,
            dialogSearchVisible:false,
            idList: [],
            reson:'',
            inquiryCode:'',
            searchData: {
                EntpCusName: '',
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                GoodCode:'',
                State: '',
                StaffId:'',
                QStartDate: '',
                QEndDate: '',
                UStartDate: '',
                UEndDate: '',
                page: 1,
                limit: 15
            },
            typeList: [],
            tableData: [],
            customerList: [],
            tableDataLength: 0,
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '并入在订', Value: '0' },
                { Text: '已完成', Value: '1' },
            ],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            supplierOptions:[],
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            apCodeOptions: [],
            apCodeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            SIdList:[],
            datetime: [],
            datetime1: [],
            columnShowSets:[],
            tableSetsVisible:false,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        this.getTableData();
        this.getSIdList();
        this.$util.setEnterEvent(this, this.$route.fullPath);
    },
    filters: {
        stateHandle(value) {
            if (value == 1) {
                return '已询价';
            } else if (value == 2) {
                return '已转为订单';
            } else if (value == 3) {
                return '作废询价单';
            }
        }
    },
    methods: {
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            //F2
            if (key === 113) {
                e.preventDefault();
                that.dialogSearchVisible = true;
            }
            if (key === 13) {
                e.preventDefault();
                if (that.visible) {
                    that.submitGoodsVs();
                    return;
                }else if (that.visible2) {
                    that.submitOrderCodeVs();
                    return;
                }else{
                    that.handleSearch();
                    return;
                }
            }
            if (key === 27) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.dialogSearchVisible = false;
                }
                if (that.visible) {
                    that.visible = false;
                }
                if (that.visible2) {
                    that.visible2 = false;
                }
            }
        },
        openDialog() {
            if(this.idList.length == 0){
                this.$util.warningMsg('请至少选择一条数据');
                return
            }
            this.reson = '';
            this.visible = true;
        },
        colseDialog() {
            this.visible = false;
        },
        openDialog2() {
            this.inquiryCode = '';
            this.visible2 = true;
        },
        colseDialog2() {
            this.visible2 = false;
        },
        showSearchDialog(){
            this.dialogSearchVisible = true;
        },
        closeSearchDialog() {
            this.dialogSearchVisible = false;
        },
        resetSearch() {
            this.searchData = {
                EntpCusName: '',
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                GoodCode:'',
                State: '',
                StaffId:'',
                QStartDate: '',
                QEndDate: '',
                UStartDate: '',
                UEndDate: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.datetime = [];
            this.datetime1 = [];
        },
        handleSelectionChange(val) {
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                let arr = {
                    Id : val[i].InquiryId,
                    GoodsId : val[i].GoodsId
                }
                idList.push(arr);
            }
            this.idList = idList;
        },
        showTableSetDialog() {
            this.tableSetsVisible = true;
        },
        closetableSetDialog(isEdit) {
            this.tableSetsVisible = false;
            if (isEdit) {
                this.$util.refresh();
            }
        },
        getTableData() {
            if(this.loading)
                return
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpInquiryOrder/GetInquiryGoodsList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.loading = false;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                });
        },
        submitOrderCodeVs() {
            this.visible2 = false;

            this.$util
                .axiosGet({
                    url: '/api/EntpInquiryOrder/SetOverInquiryOrder',
                    data: { OrderCode : this.inquiryCode}
                })
                .then(res => {
                    if(res.errcode == 0){
                        this.$util.successMsg(res.errmsg);
                        this.inquiryCode = '';
                        this.getTableData();
                    }else
                        this.$util.warningMsg(res.errmsg);

                });
        },
        submitGoodsVs() {
            if(this.idList.length == 0){
                this.$util.warningMsg('请至少选择一条数据');
                return;
            }
            let data = {
                Reson:this.reson,
                list:this.idList
            }
            this.visible = false;
            this.$util
                .axiosPost({
                    url: '/api/EntpInquiryOrder/SetOverInquiryGoodsDetail',
                    data: data
                })
                .then(res => {
                    if(res.errcode == 0){
                        this.$util.successMsg(res.errmsg);
                        this.idList = [];
                        this.reson = '';
                        this.colseDialog();
                        this.getTableData();
                    }else
                        this.$util.warningMsg(res.errmsg);
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        toNewPage(id) {
            this.$router.push(`/purchaseManage/inquirySheet/edit?type=1&id=${id}`);
        },
        // 供应商列表，搜索
        async searchSupplier(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supplierOptions = [];
            }
            if (this.supplierForm.stopLoad) return;
            const data = await this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit);
            if (data) {
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.supplierOptions = [...this.supplierOptions, ...data];
            }
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchSupplier();
        },
        searchAPCode(key, cb) {
            if (![undefined].includes(key)) {
                this.apCodeForm.Page = 1;
                this.apCodeForm.stopLoad = false;
                this.apCodeForm.key = key;
                this.apCodeOptions = [];
            }
            let callback = cb;
            if (this.apCodeForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.apCodeForm.key, 0, this.apCodeForm.Page, this.apCodeForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.apCodeForm.stopLoad = data.length < this.apCodeForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.apCodeOptions = [...this.apCodeOptions, ...arr];
                if (callback) {
                    callback(this.apCodeOptions);
                }
            });
        },
        searchGoodName(key, cb) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            let callback = cb;
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.goodNameOptions = [...this.goodNameOptions, ...arr];
                if (callback) {
                    callback(this.goodNameOptions);
                }
            });
        },
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        // 搜索顾客
        searchCustomer(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.customerList = [];
            }
            if (this.supplierForm.stopLoad) return;
            this.loading = true;
            this.$util
                .searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit)
                .then(data => {
                    this.loading = false;
                    if (!data) return;
                    this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                    this.customerList = this.$util.uniqueArr(this.customerList, data);
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.supplierForm.Page += 1;
            this.searchCustomer();
        },
        searchAutoSerise(key, cb) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            let callback = cb;
            if (this.autoSeriseForm.stopLoad) return;
            this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...arr];
                if (callback) {
                    callback(this.autoSeriseOptions);
                }
            });
        },
        stopSearch() {
            this.canSearch = false;
        },
        getSIdList() {
            this.$util.getSIdList().then((data) => {
                this.SIdList = data;
            });
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.QStartDate = val[0];
                this.searchData.QEndDate = val[1];
            } else {
                this.searchData.QStartDate = '';
                this.searchData.QEndDate = '';
            }
        },
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        selectInit(row, index) {
            if (row.IsTrans) return false;
            else return true;
        }
    }
};
</script>
<style lang="less" scoped>
#search-inquiry-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
}
#change-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
}
.dialog-footer {
    margin-top: 10px;
    text-align: right;
}
.search-item-dialog {
    width: 340px;
    height: auto;
    .el-form-item {
        margin-bottom: 0;
    }
}
.input-label{
    width: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>